import { createContext, FC, PropsWithChildren, useState } from "react";
import { PatientManagementContextType } from "./types";
export const PatientManagementContext =
  createContext<PatientManagementContextType>({
    editedField: null,
    setEditedField: () => {},
  });
const PatientManagementPlanProvider: FC<PropsWithChildren> = ({ children }) => {
  const [editedField, setEditedField] = useState<
    "managementPlan" | "treatmentPlan" | "clinicalImpression" | null
  >(null);
  return (
    <PatientManagementContext.Provider
      value={{
        editedField,
        setEditedField,
      }}
    >
      {children}
    </PatientManagementContext.Provider>
  );
};

export default PatientManagementPlanProvider;
